import React from 'react';
import * as styledComponents from './styles';
import { useHistory } from "react-router-dom";
import parse from 'html-react-parser';

const ItemElement = ({ item, addItemToCart }) => {
  const history = useHistory();
  const showItemDetail = () => {
    history.push(`/shop/detail/${item.id}`);
  }
  return (
    <styledComponents.ItemElementContainer>
      <styledComponents.Item>
        <styledComponents.AddItemContainer onClick={() => addItemToCart(item)}>
          <styledComponents.AddItem />
        </styledComponents.AddItemContainer>
        <styledComponents.Title onClick={showItemDetail}>{item.attributes.name.toUpperCase()}</styledComponents.Title>
        <styledComponents.Image onClick={showItemDetail} src={`http://localhost:1337${item.attributes.image.data.attributes.url}`} />
        <styledComponents.Price>{item.attributes.priceEUR} €</styledComponents.Price>
        <styledComponents.Description>{parse(item.attributes.description)}</styledComponents.Description>
        <styledComponents.SeeMoreButton onClick={showItemDetail}>See More...</styledComponents.SeeMoreButton>
      </styledComponents.Item>
    </styledComponents.ItemElementContainer>
  );
}

export default ItemElement;
